import { render, staticRenderFns } from "./DocumentLoanInformation.vue?vue&type=template&id=6e972570&scoped=true&"
import script from "./DocumentLoanInformation.vue?vue&type=script&lang=js&"
export * from "./DocumentLoanInformation.vue?vue&type=script&lang=js&"
import style0 from "./DocumentLoanInformation.vue?vue&type=style&index=0&id=6e972570&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e972570",
  null
  
)

export default component.exports